<template>
    <div class="vertical-wrapper">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'report-view'
}
</script>